<template>
  <div v-show="show" @click.self="dismiss" class="modal-bg">
    <div class="modal">

      <h1 class="txt-bold">Käyttöehdot</h1>
      <div class="oflow-y-auto mt-4 border-l3 p-2" style="max-height: 350px;">
        <h2 class="mb-4">Tekijänoikeudet</h2>
        <p class="font-7 lheight-9">
          Tämän sivuston sisältö on suojattu tekijänoikeuslain mukaisesti.
          <br><br>
          Tekijänoikeuslaki koskettaa erityisesti sivustolla esiintyviä valokuvia. Valokuville on myönnetty käyttöoikeus vain tälle sivustolle, eikä sitä voida välittää eteenpäin kolmansille osapuolille.
          Sivuilla esitettyä muuta graafista materiaalia (pohjapiirustuksia, leikkauskuvia ja aksonometrioita) on sallittua käyttää ei-kaupallisiin, kuten tutkimuksellisiin, journalistisiin ja koulutuksellisiin tarkoituksiin sillä edellytyksellä, että lähde mainitaan niitä käytettäessä.
          <br><br>
          Muilta sivustoilta on lupa linkittää tälle sivustolle. Tässä edellytetään kuitenkin hyvän tavan noudattamista.
          <br><br>
          Sivuja saa katsella, selata ja tulostaa käyttäjän omaa, henkilökohtaista käyttöä varten sekä lähettää sähköpostitse tai jakaa muilla tavoin haluamilleen vastaanottajille.
        </p>
        <h2 class="mt-8 mb-4">Vastuuvapaus</h2>
        <p class="font-7 lheight-9">
          Sivuston laatijat ovat monin keinoin pyrkineet varmistamaan kaiken sivustolla esitettävän tiedon oikeellisuuden. Silti laatijat eivät anna ehdotonta takuuta sivuilla esitettävien tai sitä kautta saavutettavien tietojen oikeellisuudesta. Sivuston laatijat pidättävät oikeuden tehdä sivustolle muutoksia.
          <br><br>
          Sivuilla on linkkejä kolmansien osapuolien omistamille tai ylläpitämille sivuille. Näille siirryttäessä palvelu avaa ulkopuolisen palveluntarjoajan sivuston uuteen selainikkunaan. Tällaisille sivuille siirtyessään käyttäjän on tutustuttava ja hyväksyttävä niiden mahdolliset käyttöehdot ennen käytön aloittamista. Tämän sivuston ylläpitäjällä ei ole mahdollisuuksia vaikuttaa tai vastata näiden sivustojen sisällöstä.
          <br><br>
          Sivuston ylläpitäjä ei vastaa sivuston ja siellä olevien tietojen käytön välittömästi tai välillisesti aiheuttamista vahingoista.
        </p>
      </div>
      <br>
      <button @click="dismiss" class="btn txt-center">Sulje</button>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
      // default: false
    }
  },

  data () {
    return {

    }
  },

  created () {
    const escapeHandler = e => {
      if (e.key === 'Escape' && this.show) {
        this.dismiss()
      }
    }
    document.addEventListener('keydown', escapeHandler)
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler)
    })
  },

  methods: {
    dismiss () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
</style>
